import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "page1" }
const _hoisted_2 = {
  key: 1,
  class: "pageC"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "name" }
const _hoisted_5 = { class: "time" }
const _hoisted_6 = { class: "openTime" }
const _hoisted_7 = ["id"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_empty = _resolveComponent("van-empty")!
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.dhrecordList.length == 0)
      ? (_openBlock(), _createBlock(_component_van_empty, {
          key: 0,
          style: {"margin":"50% 0"},
          description: "暂无记录"
        }))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dhrecordList, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "product",
              key: index
            }, [
              (item.winStatus ==0)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: _normalizeClass(["status", item.writeOffStatus == 0 ? 'status_red' : 'status_gray'])
                  }, _toDisplayString(item.writeOffStatus == 0 ? `未核销` : `已核销`), 3))
                : _createCommentVNode("", true),
              _createElementVNode("img", {
                src: item.winStatus ==0 ? _ctx.smileImg :item.winStatus ==1 ? _ctx.waitingImg:_ctx.cryImg ,
                class: "kjimg"
              }, null, 8, _hoisted_3),
              _createVNode(_component_van_row, { class: "justify-between items-center product" }, {
                default: _withCtx(() => [
                  _createVNode(_component_van_col, { span: "18" }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_4, _toDisplayString(item.projectName), 1),
                      _createElementVNode("div", _hoisted_5, "有效期至" + _toDisplayString(item.validTime), 1),
                      _createElementVNode("div", _hoisted_6, "开奖时间" + _toDisplayString(item.openTime), 1)
                    ]),
                    _: 2
                  }, 1024),
                  _createVNode(_component_van_col, { span: "6" }, {
                    default: _withCtx(() => [
                      (item.winStatus ==0)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            class: "code",
                            id: 'jsbarcodeImg' + index,
                            style: {"width":"110px"}
                          }, null, 8, _hoisted_7))
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024)
            ]))
          }), 128))
        ]))
  ]))
}